/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicationCreateSecretRequest
 */
export interface ApplicationCreateSecretRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationCreateSecretRequest
     */
    applicationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationCreateSecretRequest
     */
    displayName?: string | null;
    /**
     * 
     * @type {any}
     * @memberof ApplicationCreateSecretRequest
     */
    expires?: any | null;
}

/**
 * Check if a given object implements the ApplicationCreateSecretRequest interface.
 */
export function instanceOfApplicationCreateSecretRequest(value: object): value is ApplicationCreateSecretRequest {
    return true;
}

export function ApplicationCreateSecretRequestFromJSON(json: any): ApplicationCreateSecretRequest {
    return ApplicationCreateSecretRequestFromJSONTyped(json, false);
}

export function ApplicationCreateSecretRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationCreateSecretRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'displayName': json['displayName'] === undefined ? undefined : json['displayName'] === null ? null : json['displayName'],
        'expires': json['expires'] === undefined ? undefined : json['expires'] === null ? null : json['expires'],
    };
}

export function ApplicationCreateSecretRequestToJSON(json: any): ApplicationCreateSecretRequest {
    return ApplicationCreateSecretRequestToJSONTyped(json, false);
}

export function ApplicationCreateSecretRequestToJSONTyped(value?: ApplicationCreateSecretRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'displayName': value['displayName'],
        'expires': value['expires'],
    };
}

